import { render, staticRenderFns } from "./ProgrammeSubject.vue?vue&type=template&id=ac57cb58&"
import script from "./ProgrammeSubject.vue?vue&type=script&lang=js&"
export * from "./ProgrammeSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports